import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    loggedInClient: undefined,
    companyId: undefined,
    userRole: undefined,
    vendorClients: [],
    vendorSubPrjCountries: [],
    vendorSubProjServiceTypes: [],
    vendorSubProjProdSubSeg: [],
    vendorSubProjTechType: [],
    vendorSubProjAssignees: [],
    vendorSubProjBussinessUnits: [],
    vendorSubProjBrandNames: [],
    vendorPortalNotificationList: [],
    vendorCurrencyList: [],
    vendorSampleList: [],
    isParentClient: false,
    clientList: [],
    selClientList: [],
    modelNames: [],
    serviceCode: [],
    modelNamesWithIAProjects: [],
    factoryAuditNotifyCount: undefined,
    certExpInSixMonthCount: undefined,
    certRenewalReminderCount: undefined,
    lastTwoMonthUpdRegCount: undefined,
    reqUpdLastTwoMonthCount: undefined,
    bvLocations: [],
    bvCertLocations: [],
    countryCertProjects: [],
    woModelNames: [],
    woCountry: [],
    clientProductlst: [],
    subscriptionDetails: undefined,
    brandNames: [],
    certIAUploadProjectBrandNames: [],
    brandNamesWithIAProjects: [],
    brandNamesCertProjects: [],
    woBrandNames: [],
    countryTerritoryList: [],
    productTypeList: [],
    serviceTypeList: [],
    technologyTypeList: [],
    mainProductTypeList: [],
    regionCountryList: [],
    documentStatusList: [],
    projectPieChartSearchList: [],
    modelNamesCertProjects: [],
    isAuthenticated: false,
    clientProfileDetails: undefined,
    keywordSearchStr: undefined,
    getClientUserScreenAccess: undefined,
    lstClientVendor: [],
};
// Create the slice
const applicationContextSlice = createSlice({
    name: 'applicationContext',
    initialState,
    reducers: {
        setLoggedInClient: (state, action) => {
            state.loggedInClient = action.payload;
        },
        setCompanyId: (state, action) => {
            state.companyId = action.payload;
        },
        setUserRoleStored: (state, action) => {
            state.userRole = action.payload;
        },
        setVendorClients: (state, action) => {
            state.vendorClients = action.payload;
        },
        setVendorSubPrjCountries: (state, action) => {
            state.vendorSubPrjCountries = action.payload;
        },
        setVendorSubProjServiceTypes: (state, action) => {
            state.vendorSubProjServiceTypes = action.payload;
        },
        setVendorSubProjProdSubSeg: (state, action) => {
            state.vendorSubProjProdSubSeg = action.payload;
        },
        setVendorSubProjTechType: (state, action) => {
            state.vendorSubProjTechType = action.payload;
        },
        setVendorSubProjAssignees: (state, action) => {
            state.vendorSubProjAssignees = action.payload;
        },
        setVendorSubProjBussinessUnits: (state, action) => {
            state.vendorSubProjBussinessUnits = action.payload;
        },
        setVendorSubProjBrandNames: (state, action) => {
            state.vendorSubProjBrandNames = action.payload;
        },
        setVendorPortalNotificationList: (state, action) => {
            state.vendorPortalNotificationList = action.payload;
        },
        setVendorCurrencyList: (state, action) => {
            state.vendorCurrencyList = action.payload;
        },
        setVendorSampleList: (state, action) => {
            state.vendorSampleList = action.payload;
        },
        setIsParentClient: (state, action) => {
            state.isParentClient = action.payload;
        },
        setClientList: (state, action) => {
            state.clientList = action.payload;
        },
        setSelClientList: (state, action) => {
            state.selClientList = action.payload;
        },
        setModelNames: (state, action) => {
            state.modelNames = action.payload;
        },
        setServiceCode: (state, action) => {
            state.serviceCode = action.payload;
        },
        setModelNamesWithIAProjects: (state, action) => {
            state.modelNamesWithIAProjects = action.payload;
        },
        setFactoryAuditNotifyCount: (state, action) => {
            state.factoryAuditNotifyCount = action.payload;
        },
        setCertExpInSixMonthCount: (state, action) => {
            state.certExpInSixMonthCount = action.payload;
        },
        setCertRenewalReminderCount: (state, action) => {
            state.certRenewalReminderCount = action.payload;
        },
        setLastTwoMonthUpdRegCount: (state, action) => {
            state.lastTwoMonthUpdRegCount = action.payload;
        },
        setReqUpdLastTwoMonthCount: (state, action) => {
            state.reqUpdLastTwoMonthCount = action.payload;
        },
        setBvLocations: (state, action) => {
            state.bvLocations = action.payload;
        },
        setBvCertLocations: (state, action) => {
            state.bvCertLocations = action.payload;
        },
        setCountryCertProjects: (state, action) => {
            state.countryCertProjects = action.payload;
        },
        setWoModelNames: (state, action) => {
            state.woModelNames = action.payload;
        },
        setWoCountry: (state, action) => {
            state.woCountry = action.payload;
        },
        setClientProductlst: (state, action) => {
            state.clientProductlst = action.payload;
        },
        setSubscriptionDetails: (state, action) => {
            state.subscriptionDetails = action.payload;
        },
        setBrandNames: (state, action) => {
            state.brandNames = action.payload;
        },
        setCertIAUploadProjectBrandNames: (state, action) => {
            state.certIAUploadProjectBrandNames = action.payload;
        },
        setBrandNamesWithIAProjects: (state, action) => {
            state.brandNamesWithIAProjects = action.payload;
        },
        setBrandNamesCertProjects: (state, action) => {
            state.brandNamesCertProjects = action.payload;
        },
        setModelNamesCertProjects: (state, action) => {
            state.modelNamesCertProjects = action.payload;
        },
        setWoBrandNames: (state, action) => {
            state.woBrandNames = action.payload;
        },
        setCountryTerritoryList: (state, action) => {
            state.countryTerritoryList = action.payload;
        },
        setProductTypeList: (state, action) => {
            state.productTypeList = action.payload;
        },
        setServiceTypeList: (state, action) => {
            state.serviceTypeList = action.payload;
        },
        setTechnologyTypeList: (state, action) => {
            state.technologyTypeList = action.payload;
        },
        setMainProductTypeList: (state, action) => {
            state.mainProductTypeList = action.payload;
        },
        setRegionCountryList: (state, action) => {
            state.regionCountryList = action.payload;
        },
        setDocumentStatusList: (state, action) => {
            state.documentStatusList = action.payload;
        },
        setProjectPieChartSearchList: (state, action) => {
            state.projectPieChartSearchList = action.payload;
        },
        setIsAuthenticated: (state, action) => {
            state.isAuthenticated = action.payload;
        },
        clearState: () => initialState,
        setClientProfileDetails: (state, action) => {
            state.clientProfileDetails = action.payload;
        },
        setKeywordSearchStr: (state, action) => {
            state.keywordSearchStr = action.payload;
        },
        setClientUserScreenAccess: (state, action) => {
            state.getClientUserScreenAccess = action.payload;
        },
        setLstClientVendor: (state, action) => {
            state.lstClientVendor = action.payload;
        },
    },
});
// Export the actions and reducer
export const { setLoggedInClient, setCompanyId, setUserRoleStored, setVendorClients, setVendorSubPrjCountries, setVendorSubProjServiceTypes, setVendorSubProjProdSubSeg, setVendorSubProjTechType, setVendorSubProjAssignees, setVendorSubProjBussinessUnits, setVendorSubProjBrandNames, setVendorPortalNotificationList, setVendorCurrencyList, setVendorSampleList, setIsParentClient, setClientList, setSelClientList, setModelNames, setServiceCode, setModelNamesWithIAProjects, setFactoryAuditNotifyCount, setCertExpInSixMonthCount, setCertRenewalReminderCount, setLastTwoMonthUpdRegCount, setReqUpdLastTwoMonthCount, setBvLocations, setBvCertLocations, setCountryCertProjects, setWoModelNames, setWoCountry, setClientProductlst, setSubscriptionDetails, setBrandNames, setCertIAUploadProjectBrandNames, setBrandNamesWithIAProjects, setBrandNamesCertProjects, setWoBrandNames, setCountryTerritoryList, setProductTypeList, setServiceTypeList, setTechnologyTypeList, setMainProductTypeList, setRegionCountryList, setDocumentStatusList, setProjectPieChartSearchList, setModelNamesCertProjects, setIsAuthenticated, clearState, setClientProfileDetails, setKeywordSearchStr, setClientUserScreenAccess, setLstClientVendor, } = applicationContextSlice.actions;
export default applicationContextSlice.reducer;
